.container {
  width: 100%;
  max-width: @max-desktop;
  padding: 34px 24px 0;
  margin: 0 auto;

  .tablet({
    padding: 16px 16px 0;
    max-width: @max-tablet;
  });

  .mobile({
    max-width: 100vw;
  });
}
